<template>
  <div>
    <li>
      <div class="people-box" style="padding:unset !important;">
        <div class="people-comment">
          <a class="name"
             href="javascript:void(0)">
            {{ comment?.user?.full_name }}
          </a>
          <div class="date-time">
            <h6 class="text-content small">{{ comment?.published_at }}</h6>
          </div>

          <div class="reply">
            <p>
              {{ comment?.content }}
              <a href="javascript:void(0)" @click="replyToReply(comment)">
                Reply
              </a>
            </p>
          </div>
        </div>
      </div>
    </li>
    <div v-if="comment.comments">
      <ul class="review-list mt-2" style="margin-left: 30px">

        <Comment v-for="(c, key) in comment.comments" :comment="c" :key="key"></Comment>

      </ul>
    </div>
    <div class="modal show" id="modal-alert" :style="styles" v-if="replying">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="text-secondary"><i class="fa fa-reply"></i> Reply </h5>
            <button type="button" class="close btn" data-dismiss="modal" aria-hidden="true" ref="dismiss_reply_modal"
                    @click="cancelReply">×
            </button>
          </div>
          <div class="modal-body">
            <div class="reply bg-gray p-2 mb-1">
              <p>
                {{ active_comment?.content }}
              </p>
            </div>
            <textarea class="form-control" v-model="reply.comment" @input="saveTempReplyComment"></textarea>
            <span class="text-danger"
                  v-if="errors?.data?.errors?.comment  && this.has_errors">
                            {{ errors?.data?.errors?.comment[0] }}
            </span>
          </div>
          <div class="modal-footer">
            <a href="javascript:void(0);" v-loading="loading"
               class="btn btn-animation btn-sm mx-auto mt-sm-3 mt-2 w-100"
               @click="sendReply">
              Send Reply
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    styles: {
      display: "block"
    },
    active_comment: {},
    listing_id: "",
    reply: {
      comment_id: "",
      comment: "",
      listing_id: ""
    },
    replying: false
  }),
  name: 'Comment',
  props: ['comment'],
  computed: {
    ...mapGetters({
      'errors': 'listings/errors',
      'has_errors': 'listings/has_errors',
      'loading': 'listings/loading'
    })
  },
  methods: {
    replyToReply(comment) {
      this.active_comment = comment
      this.reply.comment_id = comment.id
      this.replying = true
      this.styles.display = "block"
    },
    cancelReply() {
      this.replying = false
    },
    sendReply() {
      this.createComment(this.reply).then(() => {
        if (!this.has_errors) {
          this.getListing(localStorage.getItem('listing_id'))
          this.$refs.dismiss_reply_modal.click()
        }
      })
    },
    saveTempReplyComment() {
      localStorage.setItem('reply_comment', this.reply.comment)
    },
    ...mapActions({
      'createComment': 'listings/addComment',
      'getListing': 'listings/getListing'
    })
  },
  created() {
    if (this.comment.listing_id !== "" && this.comment.listing_id !== null) {
      localStorage.setItem('listing_id', this.comment.listing_id)
    }
  }
}
</script>
